<template>
	<div>
      <v-toolbar dense flat>
        <v-layout row wrap>
          <v-flex>
            <v-text-field 
              dense style="width: 300px; max-width: 100%; height: 60px;"
              color="deep-orange" 
              v-model="search_text" 
              ref="search_field" 
              prepend-icon="search" 
              hide-details single-line
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <template>
        <production-channel 
          v-for="channel in channels" 
          :channel_id="channel.uuid" 
          :key="channel.uuid"
        ></production-channel>
      </template>
  </div>
</template>

<script>

import ChannelModel from '@/models/channel.js'
import ProductionChannel from './Channel.vue'

export default {
  components: {
    ProductionChannel
  },
  data () {
    return {
      search_text: ""
    }
  },
  methods: {
    title(channel) {
      return ChannelModel.title(channel);
    },
    instance(channel) {
      return ChannelModel.instance(channel);
    },
    is_transcoder(channel) {
      return ChannelModel.is_transcoder(channel);
    },
    is_cloudstreamer(channel) {
      return ChannelModel.is_cloudstreamer(channel);
    },
    can_start(channel) {
      // FIXME: käyttöoikeustarkistuksia
      return true;
    }
  },
  computed: {
    channels () {
      var self = this;
      var search = (this.search_text || "").toLowerCase();
      var channels = ChannelModel.list_active_channels();

      var ret = _.filter(channels, function(channel) {  
        if (ChannelModel.is_cloudstreamer(channel)) return true;
        if (ChannelModel.get_type(channel) == "output" && ChannelModel.is_transcoder(channel) == false) return true;
        return false;
      });

      if (this.search_text != "" && this.search_text) {
        var ret = _.filter(ret, (channel) => {
          if (ChannelModel.title(channel).toLowerCase().includes(search)) return true;
        });
      }

      return _.sortBy(ret, function(o) { return [ChannelModel.title(o)] });
    }
  }
}
</script>